module.exports = __webpack_public_path__ + "static/tudor-6fa201822d566f936d6ef297d8f3bd24.webp";